import { render, staticRenderFns } from "./StaySubmitOrder.vue?vue&type=template&id=4c0de836&"
import script from "./StaySubmitOrder.vue?vue&type=script&lang=js&"
export * from "./StaySubmitOrder.vue?vue&type=script&lang=js&"
import style0 from "./StaySubmitOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports